import { render, staticRenderFns } from "./_ArchivePrompt.vue?vue&type=template&id=2c3af0c4"
import script from "./_ArchivePrompt.vue?vue&type=script&lang=js"
export * from "./_ArchivePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports